import { useEffect, useState } from "react";
import api, { formatErr } from "../../../lib/api";
import { card, btn, btnGhost, label, inputStyle } from "../roads/_roadsCommon";

/** Ch 26.1 — Define X/Y axes and levels for the structural grid. */
export default function StructuralGridPanel({ projectId }) {
  const [model, setModel] = useState(null);
  const [grid, setGrid] = useState({ name: "Main Grid", x_axes: [], y_axes: [], levels: [] });
  const [err, setErr] = useState("");

  const reload = async () => {
    try {
      const { data } = await api.get(`/projects/${projectId}/structural-re/model`);
      setModel(data.model);
      setGrid(data.model.grid || { name: "Main Grid", x_axes: [], y_axes: [], levels: [] });
    } catch (e) { setErr(formatErr(e?.response?.data?.detail) || String(e)); }
  };
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, []);

  const save = async (g = grid) => {
    try {
      const { data } = await api.put(`/projects/${projectId}/structural-re/grid`, g);
      setGrid(data.grid);
    } catch (e) { setErr(formatErr(e?.response?.data?.detail) || String(e)); }
  };

  const addX = () => save({ ...grid, x_axes: [...grid.x_axes,
    { label: String.fromCharCode(65 + grid.x_axes.length), x_m: grid.x_axes.length * 5 }] });
  const addY = () => save({ ...grid, y_axes: [...grid.y_axes,
    { label: String(grid.y_axes.length + 1), x_m: grid.y_axes.length * 5 }] });
  const addLevel = () => save({ ...grid, levels: [...grid.levels,
    { label: grid.levels.length === 0 ? "GF" : `F${grid.levels.length}`,
      z_m: grid.levels.length * 3 }] });
  const editAxis = (axis, idx, key, val) => {
    const copy = { ...grid, [axis]: grid[axis].map((a, i) =>
      i === idx ? { ...a, [key]: key === "label" ? val : (parseFloat(val) || 0) } : a) };
    setGrid(copy);
  };
  const delAxis = (axis, idx) =>
    save({ ...grid, [axis]: grid[axis].filter((_, i) => i !== idx) });

  return (
    <div data-testid="structural-grid" style={{ display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr", gap: 12, padding: 16,
            height: "calc(100vh - 280px)", minHeight: 700 }}>
      {[
        { axis: "x_axes", title: "X-Axes (A, B, C, …)", add: addX },
        { axis: "y_axes", title: "Y-Axes (1, 2, 3, …)", add: addY },
        { axis: "levels", title: "Levels (GF, F1, F2, …)", add: addLevel },
      ].map(({ axis, title, add }) => (
        <div key={axis} style={{ ...card, padding: 12, overflowY: "auto" }}>
          <div style={label}>{title}</div>
          <table style={{ width: "100%", marginTop: 8, fontSize: 11 }}>
            <thead><tr style={{ borderBottom: "1px solid var(--pf-border)" }}>
              <th style={{ textAlign: "left", padding: 4 }}>Label</th>
              <th style={{ textAlign: "right", padding: 4 }}>{axis === "levels" ? "z (m)" : "x (m)"}</th>
              <th></th></tr></thead>
            <tbody>
              {(grid[axis] || []).map((a, i) => (
                <tr key={i} data-testid={`grid-${axis}-${i}`}>
                  <td><input data-testid={`grid-${axis}-label-${i}`}
                              style={{ ...inputStyle, padding: 1, fontSize: 11, width: 60 }}
                              value={a.label}
                              onChange={(e) => editAxis(axis, i, "label", e.target.value)}
                              onBlur={() => save()} /></td>
                  <td><input style={{ ...inputStyle, padding: 1, fontSize: 11, width: 60 }} type="number"
                              value={axis === "levels" ? (a.z_m ?? 0) : (a.x_m ?? 0)}
                              onChange={(e) => editAxis(axis, i,
                                axis === "levels" ? "z_m" : "x_m", e.target.value)}
                              onBlur={() => save()} /></td>
                  <td><button style={{ ...btnGhost, padding: "1px 5px", fontSize: 10 }}
                                 onClick={() => delAxis(axis, i)}>×</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <button data-testid={`grid-${axis}-add`} style={{ ...btn, width: "100%", marginTop: 8 }}
            onClick={add}>+ Add</button>
        </div>
      ))}
      {err && <div style={{ position: "absolute", bottom: 8, color: "#FF8888" }}>{err}</div>}
    </div>
  );
}
